<template>
  <multiple_form
    :forms="forms"
    :edit="props.isEdit"
    :editData="props.editData"
    :itemCol="12"
    @submit="handelSubmit"
  />
</template>
<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import { message } from 'ant-design-vue'
  import { createData, updateData } from '@/api/car_application/car_mark'
  import multiple_form from '@/components/multiple_form'
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
  })
  const emit = defineEmits(['submit'])

  //编辑、新增的表单
  const forms = computed(() => [
    {
      id: 'car_person',
      formItem: [
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
        },
        {
          type: 'select',
          storeOptions: 'carModel',
          field: 'vehicle_type_id',
          label: '车型',
        },
        {
          type: 'input',
          field: 'visitor_company',
          label: '来访单位',
        },
        {
          type: 'select',
          storeOptions: 'labelColor',
          field: 'color_id',
          label: '标记颜色',
          filterNegative:true,
        },
        {
          type: 'select',
          storeOptions: 'labelType',
          field: 'label_type_id',
          label: '标记类型',
          filterNegative: true,
        },
        {
          type: 'select',
          storeOptions: 'labelAlarmType',
          field: 'alarm_id',
          filterNegative: true,
          label: '告警类型',
        },
        {
          type: 'input',
          field: 'remark',
          label: '标记原因',
        },
        {
          type: 'imgUpload',
          field: 'photo',
          label: '现场图片',
          number: 9
        },
        // {
        //   type: 'select',
        //   storeOptions: 'labelStatus',
        //   field: 'status',
        //   filterNegative:true,
        //   label: '状态',
        //   hidden: !props.isEdit,
        // },
        // {
        //   type: 'textarea',
        //   field: 'cancel_reason',
        //   label: '取消理由',
        //   hidden: !props.isEdit,
        // },
      ],
    },
  ])

  async function handelSubmit(data) {
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}
    const res = await ajaxFn({ ...data, ...id })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }
</script>
